/* eslint-disable @typescript-eslint/no-explicit-any */
import { App } from 'vue'
import * as vueFinalModal from 'vue-final-modal'

export default function install(app: App<Element>) {
  app.use((vueFinalModal as any).default)
}

export function showModal(component: 'ModalNextVisit' | 'ModalFirstVisit', params = {}) {
  (vueFinalModal as any).$vfm.show({ component }, params)
}

export function hideModals(...names: string[]) {
  if(names) {
    (vueFinalModal as any).$vfm.hide(names)
  } else {
    (vueFinalModal as any).$vfm.hideAll()
  }
}
